<div class="wrapper" [ngClass]="{ hideBar: !stateName }">
    <div class="container">
        <div class="main-nav">
            <div *ngIf="stateName" class="for-educators-notice">For {{ stateName }} Educators</div>
            <div class="buttons-group-wrapper">
                <div class="subjects-selector-opener-wrapper">
                    <button
                        class="selenium-navigation-subjects-selector"
                        [ngStyle]="{
                            'background-color':
                                isSubjectsPanelOpened === true ? '#0a145a' : 'transparent'
                        }"
                        (click)="toggleSubjectsPanel()"
                    >
                        Subjects
                        <div *ngIf="isSubjectsPanelOpened" class="arrow-up"></div>
                        <div *ngIf="!isSubjectsPanelOpened" class="arrow-down"></div>
                    </button>
                    <div *ngIf="isSubjectsPanelOpened" class="arrow-indicator"></div>
                </div>
                <div class="grades-selector-wrapper">
                    <button
                        class="selenium-navigation-grades-selector"
                        [ngStyle]="{
                            'background-color':
                                isGradesPanelOpened === true ? '#0a145a' : 'transparent'
                        }"
                        (click)="toggleGradesPanel()"
                    >
                        Grades
                        <div *ngIf="isGradesPanelOpened" class="arrow-up"></div>
                        <div *ngIf="!isGradesPanelOpened" class="arrow-down"></div>
                    </button>
                    <div *ngIf="isGradesPanelOpened" class="arrow-indicator"></div>
                    <div
                        class="grades-panel"
                        *ngIf="isGradesPanelOpened"
                        (mouseleave)="isGradesPanelOpened = false"
                    >
                        <button
                            class="{{ gtmPrefix + 'grades-selector' }}"
                            [attr.data-gtmlabel]="'PreK'"
                            (click)="
                                router.navigate(['/grades/prek/']); isGradesPanelOpened = false
                            "
                        >
                            PreK
                        </button>
                        <button
                            class="{{ gtmPrefix + 'grades-selector' }}"
                            [attr.data-gtmlabel]="'Early Elementary'"
                            (click)="
                                router.navigate(['/grades/early-elementary/']);
                                isGradesPanelOpened = false
                            "
                        >
                            Early Elementary
                        </button>
                        <button
                            class="{{ gtmPrefix + 'grades-selector' }}"
                            [attr.data-gtmlabel]="'Upper Elementary'"
                            (click)="
                                router.navigate(['/grades/upper-elementary/']);
                                isGradesPanelOpened = false
                            "
                        >
                            Upper Elementary
                        </button>
                        <button
                            class="{{ gtmPrefix + 'grades-selector' }}"
                            [attr.data-gtmlabel]="'Middle School'"
                            (click)="
                                router.navigate(['/grades/middle-school/']);
                                isGradesPanelOpened = false
                            "
                        >
                            Middle School
                        </button>
                        <button
                            class="{{ gtmPrefix + 'grades-selector' }}"
                            [attr.data-gtmlabel]="'High School'"
                            (click)="
                                router.navigate(['/grades/high-school/']);
                                isGradesPanelOpened = false
                            "
                        >
                            High School
                        </button>
                    </div>
                </div>
                <button
                    class="selenium-navigation-browse-standards"
                    (click)="router.navigate(['/standards/0/'])"
                >
                    Standards
                </button>
                <button class="for-students" (click)="router.navigate(['/student/'])">
                    For Students
                    <em class="fas fa-external-link-alt"></em>
                </button>
            </div>
        </div>
    </div>
    <div class="subjects-panel">
        <div
            class="container subjects-wrapper"
            *ngIf="isSubjectsPanelOpened"
            (mouseleave)="isSubjectsPanelOpened = false"
        >
            <div class="subject-frame" *ngFor="let subject of subjects">
                <button
                    class="{{ 'parent-subject' + ' ' + gtmPrefix + 'discipline' }}"
                    [attr.data-gtmlabel]="subject.title"
                    [ngStyle]="{
                        color: matchSubjectColour(subject.id, predefinedSubjectsList)
                    }"
                    (click)="
                        router.navigate(['/subjects/' + subject.slug]);
                        isSubjectsPanelOpened = false
                    "
                >
                    {{ subject.title }}
                </button>
                <button
                    class="{{ 'child-subject ' + gtmPrefix + 'subject-child' }}"
                    [attr.data-gtmlabel]="child.title"
                    *ngFor="let child of getAvailableSubjects(subject)"
                    (click)="router.navigate([child.getBrowseURL()]); isSubjectsPanelOpened = false"
                >
                    {{ child.title }}
                </button>
            </div>
        </div>
    </div>
</div>
